import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMultiCustomerQuickInfo extends Layout {
    sourceCustomer: DataSource;
    tableCustomers: Table;
}
